module.exports = __webpack_public_path__ + "dam.jpg?30431e7a0e6567e2cde0ff799cc6023f";